module.exports = __webpack_public_path__ + "img/129.10.675c05b9.png";